import React from 'react'

import './navigation.css'

function NavigationCard({ label, handleClick, desc, hideArrow }) {
  return (
    <div
      className="profile-navigation-card trackable"
      onClick={handleClick}
      data-name={label}
    >
      <div className="navigation-text light">
        {label}
        <div className="navigation-desc light">{desc}</div>
      </div>
      {!hideArrow && (
        <span className="icon-arrow-bold-right righticon icon-arrow" />
      )}
    </div>
  )
}

export default NavigationCard
